






































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator'

@Component
export default class DatePickerComponent extends Vue {
  @PropSync("date", { type: String , default: "", required: true })
  syncDate!: string

  /* カレンダー入力の制御 */
  @Prop({ default: "" })
  name!: string

  @Prop({ default: false })
  required!: boolean

  @Prop({ default: false })
  readonly!: boolean

  @Prop({ default: false })
  disabled!: boolean

  @Prop({ default: false })
  clearable!: boolean

  @Prop({ default: "" })
  label!: string

  @Prop({ default: "" })
  placeholder!: string

  @Prop({ default: "mdi-calendar" })
  appendIcon!: string

  @Prop({ default: "" })
  rules!: string

  /** カレンダーの表示制御 */
  isView = false

  /** 日付 */
  dateFormatted: string | null = ""

  /**
   * 初期表示
   */
  mounted () {
    this.dateFormatted = this.syncDate.replace(/-/g, "/")
  }

  /**
   * 内部値を表示フォーマットに変換
   */
  @Watch("syncDate")
  changeValue() {
    this.dateFormatted = this.syncDate.replace(/-/g, "/")
  }

  /**
   * 入力を内部フォーマットに変換
   */
  onChange() {
    if (this.dateFormatted === null) {
      this.syncDate = ""
      this.dateFormatted = ""
      return
    }

    /* 年ありに統一 */
    const year = this.now().getFullYear()
    const inputDate = ((this.dateFormatted.match(/^\d{1,2}\/\d{1,2}$/) ? year.toString() + "/" : "") + this.dateFormatted).replace(/-/g, "/")

    /* 書式チェック */
    if (!inputDate.match(/^\d{4}\/\d{1,2}\/\d{1,2}$/)) {
      this.syncDate = ""
      this.dateFormatted = ""
      return
    }

    /* 日付チェック */
    const parts = inputDate.split("/")
    if (parts.length != 3) {
      this.syncDate = ""
      this.dateFormatted = ""
      return
    }
    const y = Number.parseInt(parts[0])
    const m = Number.parseInt(parts[1]) - 1
    const d = Number.parseInt(parts[2])
    const date = new Date(y, m, d)
    date.setTime(date.getTime() + 1000 * 60 * 60 * 9)

    if (date.getUTCFullYear() != y || date.getUTCMonth() != m || date.getUTCDate() != d) {
      this.syncDate = ""
      this.dateFormatted = ""
      return
    }

    /* 内部フォーマットに変換 */
    this.syncDate = date.toISOString().substr(0, 10)
    this.dateFormatted = this.syncDate.replace(/-/g, "/")
  }

  /**
   * 現在の日時を取得する
   */
  private now() {
      const now = new Date()
      /* ISO書式で日本時間になるように時間をずらす */
      now.setTime(now.getTime() + 1000 * 60 * 60 * 9)
      return now
  }
}
